import React from 'react';
import InputBase from '@material-ui/core/InputBase';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';


function TextField(props) {
  const { classes } = props;
  const label = props.label
    ? (
      <InputLabel
        shrink
        required={props.required}
        htmlFor="label-input"
      >
        {props.label}
      </InputLabel>
    )
    : null;

  const margin = props.label
      ? { marginTop: 5 }
      : {};

  const underline = props.disableUnderline
      ? ''
      : classes.cssUnderline;

  return (
    <FormControl
      style={props.formControlStyle}
      className={classes.margin}
    >
      <Typography>{label}</Typography>
      <InputBase
        style={{ ...margin, ...props.style }}
        classes={{
          root: classes.textFieldRoot,
          focused: classes.focused,
          input: underline,
        }}
        label={props.label}
        value={props.value || null}
        disabled={props.disabled}
        required={props.required}
        className={props.className}
        type={props.type}
        rows={props.rows}
        // tabIndex={props.tabIndex}
        multiline={props.multiLine}
        onChange={props.onChange}
        inputProps={{ tabIndex: props.tabIndex }}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        placeholder={props.placeholder}
        onKeyPress={props.onKeyPress}
        // helperText={props.helperText}
        // inputProps={props.inputProps}
        endAdornment={props.endAdornment}
        // InputLabelProps={{
        //   FormLabelClasses: {
        //     root: classes.inputLabelRoot,
        //     focused: classes.focused,
        //   },
        // }}
      />
    </FormControl>
  );
}

TextField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  endAdornment: PropTypes.any,
  tabIndex: PropTypes.number,
  formControlStyle: PropTypes.object,
  // helperText: PropTypes.string,
  style: PropTypes.object,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  classes: PropTypes.object,
  onChange: PropTypes.func,
  multiLine: PropTypes.bool,
  rows: PropTypes.number,
  onKeyPress: PropTypes.func,
  required: PropTypes.bool,
  disableUnderline: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

TextField.defaultProps = {
  classes: null,
  style: null,
  endAdornment: null,
  inputProps: {},
  formControlStyle: null,
  label: '',
  value: '',
  helperText: '',
  placeholder: '',
  className: '',
  multiLine: false,
  disabled: false,
  rows: 0,
  tabIndex: 0,
  lightStyle: false,
  disableUnderline: false,
  labelDisabled: false,
  required: false,
  onChange: () => {},
  onKeyPress: () => {},
  onFocus: () => {},
  onBlur: () => {},
};


const styles = theme => ({
  textFieldRoot: {
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    marginTop: 10,
  },

  inputLabelRoot: {
    '&$focused': {
      color: theme.palette.secondary.main,
      borderColor: theme.palette.secondary.main,
    },
  },
  margin: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: 0,
  },
  cssUnderline: {
    borderBottom: '1px solid #121212',
    '&$focused': {
      color: theme.palette.secondary.main,
      borderBottom: `1px solid ${theme.palette.secondary.main}`,
    },
  },
  focused: {},
  label: {
    fontSize: 12,
    color: '#707070',
    margin: -5,
  },
});

export default withStyles(styles)(TextField);



// WEBPACK FOOTER //
// ./src/app/components/text-field/text-field.js